import React from "react";
import { useGetAssignmentsQuery } from "../../features/assignments/assignemntsApi";

import { sortArrayBasedOnId } from "../../utils/sortArrayBasedOnId";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import SingleAssignment from "./SingleAssignment";

export default function AssignmentList() {
  const {
    data: assignments,
    isLoading,
    isError,
    error,
  } = useGetAssignmentsQuery();
  const sortedAssignments = sortArrayBasedOnId(assignments);

  // decide what to render in the ui
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && assignments?.length === 0) {
    content = (
      <div style={{ textAlign: "center", fontSize: "18px" }}>
        No assignments found! Click on the "add assignment" button to add new
        assignment.
      </div>
    );
  } else if (!isLoading && !isError && assignments?.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Title</th>
            <th className="table-th">Video Title</th>
            <th className="table-th">Mark</th>
            <th className="table-th">Action</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-600/50">
          {sortedAssignments?.map((assignment,i) => (
            <SingleAssignment key={assignment.id} index={i} assignment={assignment} />
          ))}
        </tbody>
      </table>
    );
  }

  return <>{content}</>;
}
